import React, { useEffect } from 'react'

import CssBaseline from '@material-ui/core/CssBaseline'
import EnhancedTable from './EnhancedTable'

/*
export  class TableEnseignants extends React.Component  <{}> {
 
  constructor(props) {
        super(props);
        
       // this.handleChange = this.handleChange.bind(this);
      }
    columns = [
      {
        Header: 'First Name',
        accessor: 'firstName',
      },
      {
        Header: 'Last Name',
        accessor: 'lastName',
      },
      {
        Header: 'Age',
        accessor: 'age',
      },
      {
        Header: 'Visits',
        accessor: 'visits',
      },
      {
        Header: 'Status',
        accessor: 'status',
      },
      {
        Header: 'Profile Progress',
        accessor: 'progress',
      },
    ]
  
  state = {
    data:makeData(20),
    skipPageReset:false
  }  
  //const [data, setData] = React.useState(React.useMemo(() => makeData(20), []))
 // const [skipPageReset, setSkipPageReset] = React.useState(false)

  // We need to keep the table from resetting the pageIndex when we
  // Update data. So we can keep track of that flag with a ref.

  // When our cell renderer calls updateMyData, we'll use
  // the rowIndex, columnId and new value to update the
  // original data
  componentDidMount () { 
  const updateMyData = (rowIndex, columnId, value) => {
    // We also turn on the flag to not reset the page
    this.setState({skipPageReset:true});
    this.setState({data:old =>
      old.map((row, index) => {
        if (index === rowIndex) {
          return {
            ...old[rowIndex],
            [columnId]: value,
          }
        }
        return row
      })}
    )
  }
}
  render() {
    const{columns,setData,}=this.props
  return (
    <div>
      <CssBaseline />
      <EnhancedTable
        columns={columns}
        data={this.state.data}
        setData={setData}
        updateMyData={this.updateMyData}
        skipPageReset={this.state.skipPageReset}
      />
    </div>
  )
  }
}*/

const TableEnseignants = ({handleData,handlesetTeacherid_select,dataconnected,userid,isnotenseignant}) => {
  //const isnotenseignant_prop=isnotenseignant;
  
  const columns = React.useMemo(
    () => [
      {
        Header: 'Nom',
        accessor: 'nom_enseignant',
      },
      {
        Header: 'Matière',
        accessor: 'matiere',
      },
      {
        Header: 'Email',
        accessor: 'email_enseignant',
      },
      {
        Header: 'Etat',
        accessor: 'status',
      },
     
    ],
    []
  )
  useEffect(() => {
    console.log("mounted enseignants");
   // console.log(userid);
    LoadData();
  }, []);
  useEffect(() => {
    console.log("dataconnected change");
    LoadData();
    
  }, [dataconnected]);
  
 // const [data, setData] = React.useState(React.useMemo(() => makeData(20), []))
  //const [data, setData] = React.useState(React.useMemo(() => makeData(20), []))
  const [data, setData] = React.useState(React.useMemo(() =>[], []))
  const [memodata, setMemoData] = React.useState(React.useMemo(() =>[], []))
  const [skipPageReset, setSkipPageReset] = React.useState(false)
  const [xhrencours, setXhrEncours] = React.useState(false)
 // const [dataconnected, setDataconnected] = React.useState(dataconnected)
const LoadData=()=>
{
  if(xhrencours)return;
  //var that=this;
  setXhrEncours(true);
  var xhr = new XMLHttpRequest();
  xhr.overrideMimeType("application/json");
  
  //var that=_this;
  xhr.open('GET','/api/public/getclassroom?id_user='+userid)
  
  xhr.setRequestHeader("Content-Type", "application/json");

  //send the form data
  xhr.send();

  xhr.onreadystatechange = function() {
      
     if (xhr.readyState == XMLHttpRequest.DONE) {
                    
        if(xhr.status==200) 
        { 
        
        //console.log(xhr.responseText);
        var jsonResponse = JSON.parse(xhr.responseText);
        //console.log(jsonResponse)
        if (jsonResponse != null) 
        {
          var jj = JSON.parse(jsonResponse[0]);
          var kk={ID:jj[0].ID,nom_enseignant:jj[0].nom_enseignant,id_enseignant:jj[0].id_enseignant,email_enseignant:jj[0].email_enseignant,matiere:jj[0].matiere,code:jj[0].code,status:jj[0].status,visible:jj[0].visible}
          //console.log(jsonResponse[0].length);
          if(jj.length>1){for (var t=0;t<jj.length;t++){jj[t].status=""};kk.subRows=jj;kk.matiere="";}
          var jsonResponse2=[kk];
          var jsonResponseMatieres=jj;
        }
        else {var jsonResponse2=[];var jsonResponseMatieres=[];}
        console.log(jsonResponse2);
        //console.log(jsonResponse.length);
        if (jsonResponse != null) for( var i=1; i<jsonResponse.length;i++)
        {
            var jj=JSON.parse(jsonResponse[i]);
            var kk={ID:jj[0].ID,nom_enseignant:jj[0].nom_enseignant,id_enseignant:jj[0].id_enseignant,email_enseignant:jj[0].email_enseignant,matiere:jj[0].matiere,code:jj[0].code,status:jj[0].status,visible:jj[0].visible}
            if(jj.length>1){for (var t=0;t<jj.length;t++){jj[t].status=""};kk.subRows=jj;kk.matiere="";}
            console.log(kk)
            jsonResponse2=jsonResponse2.concat(kk);
            jsonResponseMatieres=jsonResponseMatieres.concat(jj);
        }
        
        console.log(jsonResponse2);
        dataconnected.map((item)=>{
          jsonResponse2.map((item2)=>{
            if (item2.ID==item.ID)item2.status=item.etat;
          });
        });

        setData(jsonResponse2);
        
        handleData(jsonResponseMatieres);
        setMemoData(jsonResponse2);
          //toaster.show( {message:"Matière "+ uMatiere.matiere + " créée"});
         
        }
        if(xhr.status==404) {console.log( {message:"erreur"}); }
        if(xhr.status==500) {console.log( {message:"erreur"}); }
        
      
      }
      setXhrEncours(false);
      
  }
}
  const DeleteData=(stid)=>
{
  var xhr = new XMLHttpRequest();
  xhr.overrideMimeType("application/json");
  
  //var that=_this;
  xhr.open('GET','/api/public/delclassroom?id_enseignant='+stid)
  
  xhr.setRequestHeader("Content-Type", "application/json");

  //send the form data
  xhr.send();

  xhr.onreadystatechange = function() {
      if (xhr.readyState == XMLHttpRequest.DONE) {
                    
        if(xhr.status==200) 
        { 
        
        console.log(xhr.responseText);
        var jsonResponse = JSON.parse(xhr.responseText);
        console.log(jsonResponse);
        //setData(jsonResponse);
          //toaster.show( {message:"Matière "+ uMatiere.matiere + " créée"});
         
        }
        if(xhr.status==404) {console.log( {message:"erreur"}); }
        if(xhr.status==500) {console.log( {message:"erreur"}); }
        
      
      }
      
  }
}
  //const [isnotenseignant_prop, setIsNotEnseignant] = React.useState(isnotenseignant)

  // We need to keep the table from resetting the pageIndex when we
  // Update data. So we can keep track of that flag with a ref.

  // When our cell renderer calls updateMyData, we'll use
  // the rowIndex, columnId and new value to update the
  // original data
  const handleTeacherSelect=(index)=>{
    console.log(index);
    handlesetTeacherid_select(data[index].id_enseignant);
    /*data.map((item)=>{
      console.log(data);
    });*/
  }
  const updateMyData = (rowIndex, columnId, value) => {
    console.log("mounted enseignants update");
    setSkipPageReset(true)
    setData(old =>
      old.map((row, index) => {
        if (index === rowIndex) {
          return {
            ...old[rowIndex],
            [columnId]: value,
          }
        }
        return row
      })
    )
  }
  if(userid!="")if(memodata.length!=data.length){LoadData();}
  console.log("mounted enseignants before");
  return (
    <div id="id_table_enseignants" style={{display:isnotenseignant,zIndex: 0,position: 'relative'}}>
      <CssBaseline />
      <EnhancedTable
        userid={userid}
        columns={columns}
        data={data}
        handleTeacherSelect={handleTeacherSelect}
        DeleteData={DeleteData}      
        setData={setData}
        pageSize={100}
        updateMyData={updateMyData}
        skipPageReset={skipPageReset}
      />
    </div>
  )
}

export default TableEnseignants
